import React, { Component } from 'react'
import {connect} from 'react-redux'
// utils
import {Translations, convertStringToArray} from '../../../utils';
// rest client
import {eapiClient, aemHostClient} from '../../../restClient';
// children
import AddUserSearchBox from '../AdminPanel/AddUserSearchBox/'
import {CompositeList, CompositeListItem,ListRightContentSection, ItemHeading, ActionBar} from '../../common/CompositeList/compositeList';
//action creator
import {setAdminTabIndex} from '../actions/actionCreator';
//style
import './CreateGroup.css'

class CreateGroup extends Component {

  state = {
    groupName: '',
    userListData: []
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  componentWillMount(){
      aemHostClient("/aemData/formData/json_create-group")
      .then(({data}) => {
          this.setState({pageJson: data.par});
      });
      aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({data}) => {
          this.setState({darkTitleBarJson: data.par});
           document.title = `${Translations(data.par.static_text_darkTitleBar.addGroupMember,this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
      });
  }

  deleteGroup = (item) => {
    var user = this.state.userListData.filter( id => {
      return id.id !== item.id
    })

    this.setState({
      userListData: user
    })
  }

  getSelectedUser = (selectedUser) => {
    if(!this.state.userListData.find(item => selectedUser.id === item.id)) {
      this.setState({userListData: this.state.userListData.concat([selectedUser])});
    }
  }

  getInputValue = (e) => {
    this.setState({
      groupName: e.target.value
    })
  }

  cancelGroup = () => {
    this.props.setAdminTabIndex(1);
    this.props.history.push('/admin-panel/');
  }

  createGroup = () => {
    let payload = new SaveAndReturnPayload();
    payload.setPayload(this.state);

    if(this.state.groupName.length > 2 ){
      eapiClient("/usergroup/", {
        method: 'POST',
        data: JSON.stringify(payload.data)
      })
      .then(({data}) => {
        this.props.setAdminTabIndex(1);
        this.props.history.push('/admin-panel/')
      });
    }
  }

  render(){
    return(this.state.pageJson ? (
      <div className="create-group">
        <div className="create-group--section">
          <label className="group-lbl">{this.translations(this.state.pageJson.text_box_groupName.title)}</label>
          <input type="text" value={this.state.groupName} onChange={this.getInputValue}/>
        </div>
        <div className="create-group--section create-group--border-none">
          <h1>{this.translations(this.state.pageJson.type_ahead_addGroupMember.title)}</h1>
          <AddUserSearchBox
            headerTitle='Add a Group'
            setSelectedOptions={this.getSelectedUser}
          />
          <div className="group-detail--user-group-section gdocs-mtop-10">
            <CompositeList>
              {
                this.state.userListData.map( (item,key) =>
                  <CompositeListItem key={key}>
                    <ListRightContentSection>
                      <ItemHeading showArrowIcon={false}><a>{item.name}</a>({item.email}) </ItemHeading>
                    </ListRightContentSection>
                    <ActionBar _onClick={this.deleteGroup.bind(this, item)}/>
                  </CompositeListItem>)
              }
            </CompositeList>
          </div>
        </div>
        <div className="gdocs-clear-float"></div>
        <div className="create-group--section--submit">
          <div className="form-buttons-wrapper">
            <label aria-label="Add account" className="gdocs-mright-20 gdocs-cursor-pointer" onClick={this.cancelGroup}>
              {this.translations(this.state.pageJson.button_cancel.text)}
            </label>
            <button aria-label="Add account" className="gdocs-btn-submit" onClick={this.createGroup}>
             {this.translations(this.state.pageJson.button_createGroup.text)}
            </button>
          </div>
        </div>
      </div>
    ): '');
  }
}


class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayload({groupName, userListData}) {
    var userData = userListData.map(item => item.id)
    this.data = {
      group: groupName,
      users: userData
    };
  }
}

const mapStateToProps = state => ({
  lang: state.lang
})

const mapDispatchToProps = dispatch => {
  return {
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateGroup)



// WEBPACK FOOTER //
// ./src/components/Admin/GroupDetail/CreateGroup.js